var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireWithBackground = function SvgFireWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 62.526,
    height: 62.526,
    x: -17.263,
    y: -17.263
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#fireWithBackground_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#fireWithBackground_svg__b)",
    "data-figma-bg-blur-radius": 17.263
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.494 10.088c-.963 1.45-1.75 3.112-1.75 4.662a5.25 5.25 0 1 0 10.5 0c0-3.25-2.25-5.75-4.075-7.569l-2.175 4.569z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireWithBackground_svg__b",
    x1: 14,
    x2: 14,
    y1: 0,
    y2: 44.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070409",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fireWithBackground_svg__a",
    transform: "translate(17.263 17.263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14
  })))));
};
export default SvgFireWithBackground;